import React from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Divider,
  Typography,
  Button,
} from '@material-ui/core'

const DialogRemoveDataTreatment = ({
  dataProcessId,
  dataTreatmentId,
  open,
  setOpen = () => {},
  handleRemove = () => {},
}) => {
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        <Box>
          <Typography variant="h4">
            Remover compartilhamento de dados
          </Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <Box mt={1} mb={1}>
        <DialogContent>
          <Box>
            <Typography>
              Tem certeza que deseja remover este compartilhamento de dados?
            </Typography>
          </Box>
        </DialogContent>
      </Box>
      <Divider />
      <DialogActions p={2}>
        <Box pl={2} pr={1}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancelar
          </Button>
        </Box>
        <Button
          variant="contained"
          type="submit"
          color="primary"
          onClick={() => handleRemove(dataProcessId, dataTreatmentId)}
        >
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogRemoveDataTreatment
